import ApiService from "./base";
import { config } from "@/utils/config";
export default class ApiKeysService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async createApiKey(productCode, data) {
        const response = await this.post({
            url: productCode ? `/direct/${productCode}/api-keys` : `/direct/api-keys`,
            data
        });
        // Transform backend response to match frontend ApiKey model
        const apiKeyData = response.data.apiKey || response.data;
        return {
            id: apiKeyData.ApiKeyId,
            name: apiKeyData.Name || `api-key-${apiKeyData.ProductCode}-${apiKeyData.ApiKeyId.substring(0, 8)}`,
            status: apiKeyData.Status || 'Active',
            createdDate: new Date(apiKeyData.CreatedAt),
            value: apiKeyData.Value,
            productCode: apiKeyData.ProductCode,
            email: apiKeyData.Email,
            contractExpiry: apiKeyData.ContractExpiry,
            contractType: apiKeyData.ContractType,
            expiresAt: apiKeyData.ExpiresAt,
            gracePeriodDays: apiKeyData.GracePeriodDays
        };
    }
    async getAllApiKeys(productCode, customerId) {
        try {
            const params = new URLSearchParams();
            if (productCode) params.append('productCode', productCode);
            if (customerId) params.append('customerId', customerId);
            const response = await this.get({
                url: `/direct/api-keys?${params.toString()}`
            });
            const data = response.data;
            const items = data.items || data;
            // Transform backend response to match frontend ApiKey model
            const transformedItems = (Array.isArray(items) ? items : []).map((item)=>({
                    id: item.ApiKeyId,
                    name: item.Name || `api-key-${item.ProductCode}-${item.ApiKeyId.substring(0, 8)}`,
                    status: item.Status || 'Active',
                    createdDate: new Date(item.CreatedAt),
                    productCode: item.ProductCode,
                    email: item.Email,
                    customerId: item.CustomerId,
                    contractExpiry: item.ContractExpiry,
                    contractType: item.ContractType,
                    expiresAt: item.ExpiresAt,
                    gracePeriodDays: item.GracePeriodDays
                }));
            return {
                items: transformedItems,
                count: transformedItems.length,
                totalApiKeysCount: data.totalApiKeysCount || transformedItems.length,
                memberApiKeysCount: data.memberApiKeysCount || transformedItems.length
            };
        } catch (error) {
            throw error;
        }
    }
    async deleteApiKey(productCode, keyId) {
        await this.delete({
            url: productCode ? `/direct/${productCode}/api-keys/${keyId}` : `/direct/api-keys/${keyId}`
        });
    }
    async updateApiKeyStatus(productCode, keyId, action) {
        const response = await this.patch({
            url: productCode ? `/direct/${productCode}/api-keys/${keyId}/status` : `/direct/api-keys/${keyId}/status`,
            data: {
                action
            }
        });
        const apiKeyData = response.data.apiKey;
        return {
            id: apiKeyData.ApiKeyId,
            name: apiKeyData.Name,
            status: apiKeyData.Status,
            createdDate: new Date(apiKeyData.CreatedAt || Date.now()),
            productCode: apiKeyData.ProductCode,
            contractExpiry: apiKeyData.ContractExpiry,
            contractType: apiKeyData.ContractType,
            expiresAt: apiKeyData.ExpiresAt,
            gracePeriodDays: apiKeyData.GracePeriodDays
        };
    }
}
